import { render, staticRenderFns } from "./view-system-promo.vue?vue&type=template&id=45f082d1&"
import script from "./view-system-promo.vue?vue&type=script&lang=js&"
export * from "./view-system-promo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports